import { render } from "./NewTrip.vue?vue&type=template&id=475a386e"
import script from "./NewTrip.vue?vue&type=script&lang=js"
export * from "./NewTrip.vue?vue&type=script&lang=js"

import "./NewTrip.vue?vue&type=style&index=0&id=475a386e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__